export default {
      id: "customization-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.svg#customization",
      toString: function () {
        return this.url;
      }
    }